import * as ActionTypes from '../actions'



const isPatientsLoading = (state = false, action) => {
	switch (action.type) {
		case ActionTypes.LOAD_PATIENTS_REQUEST:
			return true;
		case ActionTypes.LOAD_PATIENTS_SUCCESS:
		case ActionTypes.LOAD_PATIENTS_FAILURE:
			return false;
		default:
			return state;
	}
}

export default isPatientsLoading


// WEBPACK FOOTER //
// ./src/reducers/isPatientsLoading.js